import {
  CustomerServiceOutlined,
  DollarOutlined,
  EditOutlined,
  ToolOutlined,
} from '@ant-design/icons';
import React from 'react';

// Fallback icon since CustomerOutlined may not exist
function CustomerOutlined() {
  return <CustomerServiceOutlined />;
}

/**
 * 工作站产品中心 / 控制台展示的四款产品。
 *
 * `ctx` 对应 sessionStorage 中的产品上下文（见 @/utils/consoleCtx）：
 * - 内容孵化器 / AI客服 有独立侧栏二级导航（ctx 非空）
 * - 大模型Token平台 / 企业定制 仅复用控制台基础侧栏（ctx 为空）
 *
 * 控制台首页（console）与产品切换抽屉（ProductSwitcher）共用此清单，
 * 避免两处卡片定义漂移。
 */
export interface ProductEntry {
  key: string;
  title: string;
  description: string;
  tags: string[];
  icon: React.ReactNode;
  color: string;
  path: string;
  ctx: string;
  /**
   * 进入工作台走免密 SSO 直跳 new-api（而非站内路由）。WIS-369 opt4：
   * 大模型Token平台点击等价于原模型广场右上角「Token平台控制台」按钮。
   */
  sso?: boolean;
}

export const PRODUCTS: ProductEntry[] = [
  {
    key: 'incubator',
    title: '内容孵化器',
    description: 'AI 驱动的内容生产引擎，批量生成文案、图文与短视频脚本。',
    tags: ['AI 文案', '图片生成', '爆款采集'],
    icon: <EditOutlined />,
    color: '#722ed1',
    // WIS-369 opt1：默认落点改为图文爆款复刻
    path: '/content-workstation/reference-copy',
    ctx: 'incubator',
  },
  {
    key: 'ai-service',
    title: 'AI 客服',
    description:
      '智能对话引擎，全天候接待客户、解答疑问、收集线索，提升转化率。',
    tags: ['多轮对话', '意图识别', '线索收集'],
    icon: <CustomerOutlined />,
    color: '#1890ff',
    path: '/ai-employee',
    ctx: 'ai-service',
  },
  {
    key: 'token-platform',
    title: '大模型Token平台',
    description:
      '一站式大模型 Token 管理平台，灵活充值、实时监控、多模型支持。',
    tags: ['Token 管理', '多模型', '实时监控'],
    icon: <DollarOutlined />,
    color: '#52c41a',
    // WIS-369 opt4：点击进入工作台免密直跳 new-api（见 openTokenPlatformConsole），模型广场已下线
    path: '',
    ctx: '',
    sso: true,
  },
  {
    key: 'enterprise',
    title: '企业定制',
    description: '量身打造的 AI 解决方案，满足企业个性化业务需求。',
    tags: ['模型训练', '流程定制', '私有部署'],
    icon: <ToolOutlined />,
    color: '#fa8c16',
    path: '/customization-workstation',
    ctx: '',
  },
];
